import PodcastTableGoBackButton from './PodcastTableGoBackButton';

export default PodcastTableGoBackButton;
